module.exports = __webpack_public_path__ + "img/hk10x-cover2.1f697c30.jpg";